import { render, staticRenderFns } from "./Launch.vue?vue&type=template&id=6130a6fa&scoped=true&"
import script from "./Launch.vue?vue&type=script&lang=js&"
export * from "./Launch.vue?vue&type=script&lang=js&"
import style0 from "./Launch.vue?vue&type=style&index=0&id=6130a6fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6130a6fa",
  null
  
)

export default component.exports